export default "__VITE_ASSET__1ba3e34e__"